import { css, cx } from '@emotion/css';
// eslint-disable-next-line import/extensions
import { make as LottieController } from '@prezzee/ribbon/src/components/personal/LottieController/LottieController.gen';
import { Color } from 'css/theme';
import * as React from 'react';
import { ButtonHTMLAttributes } from 'react';

export enum Variations {
  Primary = 'Primary',
  Outlined = 'Outlined',
}

type Props = {
  variation: Variations;
  disabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const getStylesFromVariation = (disabled: boolean, variation: Variations): React.CSSProperties => {
  switch (variation) {
    case Variations.Outlined:
      return {
        borderWidth: '1px',
        borderColor: disabled ? Color.LightGray : Color.DarkGray,
        color: disabled ? Color.LightGray : Color.DarkGray,
      };
    case Variations.Primary:
    default:
      return {
        backgroundColor: disabled ? Color.LightGray : Color.Primary,
        color: Color.White,
      };
  }
};

const container = (loading: boolean, disabled: boolean, variation: Variations) =>
  css({
    width: '100%',
    paddingLeft: 'auto',
    paddingRight: 'auto',
    paddingTop: '0.875rem',
    paddingBottom: '0.875rem',
    borderRadius: '10px',
    fontWeight: 600,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: loading || disabled ? 'not-allowed' : 'pointer',
    ...getStylesFromVariation(!loading && disabled, variation),
  });

const loadingIcon = css({
  width: '1.5rem',
  marginRight: '10px',
  fill: Color.White,
  stroke: Color.White,
});

const Button = ({
  variation,
  loading = false,
  disabled = false,
  children,
  className = '',
  onClick,
  type = 'button',
  ...props
}: Props) => (
  <button
    onClick={onClick}
    {...props}
    className={cx(container(loading, disabled, variation), className)}
    disabled={disabled}
    type={type}
  >
    {loading && (
      <LottieController className={loadingIcon} path="https://assets7.lottiefiles.com/packages/lf20_ly6t7nzc.json" />
    )}
    {children}
  </button>
);

export default Button;
